import axios from '../api/axios';

export const detectUserLocationData = async () => {
  try {
    const res = await axios.get('/auth/location-suggest');
    return {
      iso2: res.data?.country?.iso2 || 'GB',
      dialCode: res.data?.country?.dial_code || '+44',
      currency: res.data?.currency || 'GBP'
    };
  } catch (err) {
    console.warn('Failed to detect user location via backend:', err);
    return {
      iso2: 'GB',
      dialCode: '+44',
      currency: 'GBP'
    };
  }
};
